import CloseIcon from "@mui/icons-material/Close";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import { IconButton, Tooltip } from "@mui/material";
import React, { ReactElement, useState } from "react";

import ActivityFeed from "../../pages/detail-page/parts/activity-feed";

type Props = {
  assetId: string;
};

export default function Comments(props: Props): ReactElement {
  const { assetId } = props;

  const [messageNavigation, setMessageNavigation] = useState(false);

  return (
    <div
      style={{
        boxShadow: messageNavigation ? "-7px 7px 10px #c0c0c06e" : "none",
      }}
      className={`${
        messageNavigation ? "w-2/3 border-slate-300 border-l-1" : "w-0"
      } pl-30 ml-30 relative`}
    >
      <Tooltip title="Comments">
        <IconButton
          size="large"
          className={`${
            messageNavigation ? "bg-slate-100" : ""
          } top-0 right-0 p-10 absolute flex-col rounded-10`}
          onClick={() => setMessageNavigation(!messageNavigation)}
        >
          {messageNavigation ? <CloseIcon /> : <MessageOutlinedIcon />}
        </IconButton>
      </Tooltip>
      {messageNavigation && (
        <>
          <h2 className="text-[24px] font-bold mb-[20px] text-slate-600">
            Activity Feed
          </h2>
          <ActivityFeed assetId={assetId} />
        </>
      )}
    </div>
  );
}
